module.exports = __webpack_public_path__ + "img/DieBand.09df38b0.jpg";